import styled from 'styled-components';

const STATEMENT_OCR_HEADER_HEIGHT = 100;
export const StatementOCRLayout = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const StatementOCRMainSection = styled.div`
  bottom: 0;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: ${STATEMENT_OCR_HEADER_HEIGHT}px;
`;

export const StatementOCRHeaderSection = styled.div`
  height: ${STATEMENT_OCR_HEADER_HEIGHT}px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
